/* ============================================================
   J3 SPORTS - Motor de movimiento

   Contrato de seguridad, igual que el resto del tema:
   el contenido es VISIBLE por defecto. Este script anade
   html.j3-motion, que es lo unico que llega a ocultarlo, y si
   algo queda atascado se revela a los 2,6 s.
   Sin JS, la pagina se ve completa y quieta.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.classList.add('j3-motion');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  var watched = [];
  function watch(el) {
    watched.push(el);
    io.observe(el);
  }

  /* --- 1. Titulares: cada palabra sube tras una mascara --------
     Solo se parten los titulares de texto plano. Si el titular
     trae marcado dentro (un enlace, un span de richtext), se le
     da la subida simple: partirlo romperia ese marcado. */
  function splitHeadings() {
    var sel = '.h-h2, .l-title, .title-wrapper h2, .collection__title h2';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (el.dataset.j3Done) return;
      el.dataset.j3Done = '1';

      if (el.children.length > 0) {
        el.classList.add('j3-rise');
        watch(el);
        return;
      }

      var words = (el.textContent || '').trim().split(/\s+/);
      if (!words.length || words.length > 14) {
        el.classList.add('j3-rise');
        watch(el);
        return;
      }

      var frag = document.createDocumentFragment();
      words.forEach(function (w, i) {
        var outer = document.createElement('span');
        outer.className = 'j3-w';
        var inner = document.createElement('i');
        inner.textContent = w;
        inner.style.transitionDelay = i * 60 + 'ms';
        outer.appendChild(inner);
        frag.appendChild(outer);
        if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
      });
      el.textContent = '';
      el.appendChild(frag);
      el.classList.add('j3-t');
      watch(el);
    });
  }

  /* --- 2. Texto de apoyo y tarjetas de la home ----------------
     La grilla de coleccion ya tiene su propio revelado en
     j3-plp-head: no se toca, para no montar dos sistemas. */
  function riseTargets() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.h-sub, .collection__description, .l-desc, .l-chips'),
      function (el) {
        if (el.dataset.j3Done) return;
        el.dataset.j3Done = '1';
        el.classList.add('j3-rise');
        el.style.setProperty('--j3-d', '120ms');
        watch(el);
      }
    );

    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function (sec) {
      if (sec.querySelector('#product-grid')) return;
      var items = sec.querySelectorAll('.grid__item');
      if (!items.length) return;
      Array.prototype.forEach.call(items, function (el, i) {
        if (el.dataset.j3Done) return;
        el.dataset.j3Done = '1';
        el.classList.add('j3-rise');
        el.style.setProperty('--j3-d', Math.min(i * 40, 320) + 'ms');
        watch(el);
      });
    });
  }

  /* --- 3. Heroe: paralaje ------------------------------------
     La foto se mueve a un 12% de la pagina. Se lee con rAF y
     scroll pasivo para no bloquear el hilo del desplazamiento. */
  function parallax() {
    if (reduce.matches) return;
    var hero = document.querySelector('[id^="j3h-"]');
    if (!hero) return;
    var bg = hero.querySelector('.j3h-bg');
    if (!bg) return;

    var ticking = false;
    function apply() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var shift = Math.max(-60, Math.min(60, -r.top * 0.12));
      bg.style.setProperty('--j3-py', shift.toFixed(1) + 'px');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  /* --- 4. Agregar al carrito desde la talla -------------------
     Reemplaza al modal "Seleccionar opciones" de Dawn, que no
     funciona en esta tienda porque lee el marcado de la ficha
     original y aqui la ficha es propia (j3-pdp). */
  var toastEl = null;
  var toastTimer = null;
  function toast(msg, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'j3-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('j3-toast--err', !!isError);
    toastEl.textContent = msg;
    requestAnimationFrame(function () {
      toastEl.classList.add('is-on');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-on');
    }, 3400);
  }

  function routes() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCount() {
    fetch(routes() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(
          document.querySelectorAll('.cart-count-bubble span:first-child'),
          function (n) { n.textContent = cart.item_count; }
        );
      })
      .catch(function () {});
  }

  function addToCart(chip) {
    var id = chip.getAttribute('data-vid');
    if (!id || chip.classList.contains('is-loading')) return;

    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (err) { sections = []; }
    var hasDrawer = !!(drawer && typeof drawer.renderContents === 'function' && sections.length);

    chip.classList.add('is-loading');
    fetch(routes() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          toast(state.description || state.message || 'No pudimos agregarlo.', true);
          return;
        }
        chip.classList.add('is-added');
        setTimeout(function () { chip.classList.remove('is-added'); }, 1200);

        // El cajon del carrito ya es la confirmacion: un aviso encima seria
        // decir dos veces lo mismo. El aviso queda solo de respaldo.
        if (hasDrawer) {
          drawer.renderContents(state);
        } else {
          refreshCount();
          toast('Agregado al carrito - talla ' + chip.textContent.trim(), false);
        }
      })
      .catch(function () {
        toast('No pudimos agregarlo. Intenta de nuevo.', true);
      })
      .then(function () {
        chip.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.j3-size[data-vid]') : null;
    if (!chip) return;
    e.preventDefault();
    addToCart(chip);
  });

  /* --- 5. Arranque y red de seguridad -------------------------
     Se revela lo que siga oculto Y este realmente a la vista. No
     se retira la capa entera: las tarjetas de un carrusel estan
     fuera de pantalla por el costado y contarlas como atascadas
     apagaba todo el sistema. */
  function run() {
    splitHeadings();
    riseTargets();
    parallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);

  setTimeout(function () {
    watched.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      var r = el.getBoundingClientRect();
      var visible =
        r.top < window.innerHeight && r.bottom > 0 && r.left < window.innerWidth && r.right > 0;
      if (visible) el.classList.add('is-in');
    });
  }, 2600);
})();
